module.exports = __webpack_public_path__ + "img/coaching-count.a0a27067.svg";